import {
  KitchenOutlined,
  TvOutlined,
  CurtainsClosedOutlined,
  LocalLaundryServiceOutlined,
  MicrowaveOutlined,
  LocalDiningOutlined,
  BakeryDiningOutlined,
  AcUnitOutlined,
  HotTubOutlined,
  WallpaperOutlined,
  LightbulbOutlined,
  ThermostatOutlined,
  LocalDrinkOutlined,
  SatelliteAltOutlined,
  StorageOutlined,
  BuildOutlined,
  MoreHorizOutlined,
  WeekendOutlined,
  CountertopsOutlined,
  ShowerOutlined,
  PhoneOutlined,
  RoofingOutlined,
  LocalFireDepartmentOutlined,
  PlumbingOutlined,
  SmartScreenOutlined,
  SmokeFreeOutlined,
} from '@mui/icons-material'

export const provisionIconMap: Record<string, React.ReactNode> = {
  // เฟอร์นิเจอร์และการตกแต่ง
  'FullyFurnished': <WeekendOutlined />,
  'FullyFitted': <BuildOutlined />,
  'CurtianSet': <CurtainsClosedOutlined />,

  // เครื่องใช้ไฟฟ้าในครัว
  'KitchenSet': <KitchenOutlined />,
  'KitchenCabinet': <CountertopsOutlined />,
  'Refrigerator': <KitchenOutlined />,
  'Microwave': <MicrowaveOutlined />,
  'DishWasher': <LocalDiningOutlined />,
  'Oven': <BakeryDiningOutlined />,

  // เครื่องใช้ไฟฟ้าทั่วไป
  'TV': <TvOutlined />,
  'WashingMachine': <LocalLaundryServiceOutlined />,
  'AirConditioner': <AcUnitOutlined />,
  'WaterHeater': <HotTubOutlined />,

  // ระบบสุขาภิบาล
  'SanitaryWare': <ShowerOutlined />,

  // โครงสร้างอาคาร
  'Floor': <BuildOutlined />,
  'Wall': <WallpaperOutlined />,
  'Ceilling': <RoofingOutlined />,
  'Lighting': <LightbulbOutlined />,

  // ระบบรักษาความปลอดภัย
  'SmokeDetector': <SmokeFreeOutlined />,
  'HeatDetector': <ThermostatOutlined />,
  'WaterSprinkle': <LocalFireDepartmentOutlined />,

  // ระบบสื่อสารและเทคโนโลยี
  'VideoPhone': <PhoneOutlined />,
  'HomeAutomation': <SmartScreenOutlined />,
  'SattlelliteTV': <SatelliteAltOutlined />,

  // ระบบน้ำ
  'DrinkingWaterSystem': <LocalDrinkOutlined />,
  'Watertank': <StorageOutlined />,
  'WaterPump': <PlumbingOutlined />,

  // อื่นๆ
  'More…..': <MoreHorizOutlined />, 
}
